import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {ApplicationService} from '../../../service/application.service';
import {Dialog} from '../../../../global/util/Dialog';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {InformType} from '../../../../global/util/enum/InformType';
import {CloneTool} from '../../../../global/util/CloneTool';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {InstallerService} from '../../../service/installer.service';
import {Installer} from '../../../model/Installer';
import {AddEditInstallerComponent} from '../add-edit-installer/add-edit-installer.component';
import {MoreAboutInstaller} from '../../../model/common/MoreAboutInstaller';
import {Signatureapptype} from '../../../model/Signatureapptype';
import {Typefile} from '../../../model/Typefile';
import {Operatingsystem} from '../../../model/Operatingsystem';
import {ViewDescriptionComponent} from '../view-description/view-description.component';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';

@Component({
  selector: 'app-list-installer',
  templateUrl: './list-installer.component.html',
  styleUrls: ['./list-installer.component.css']
})
export class ListInstallerComponent implements OnInit {

  public installers: Installer[] = [];
  public page: any = {};
  public links: any = {};
  private installerUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public entityName = 'TITLE.INSTALLERS';
  public term2Search: string;
  public signatureAppTypes: Signatureapptype[] = [];
  public typefiles: Typefile[] = [];
  public operatingsystems: Operatingsystem[] = [];
  public signatureAppTypeSelected: Signatureapptype;
  public typefileSelected: Typefile;
  public operatingsystemSelected: Operatingsystem;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public installerService: InstallerService,
              public modalService: NgbModal,
              public authenticationService: AuthService,
              public applicationService: ApplicationService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.signatureAppTypes = LocalStorage.getSignatureapptypeExtra();
    this.signatureAppTypeSelected = this.signatureAppTypes[Constant.ZERO_INDEX];
    this.typefiles = LocalStorage.getTypefileExtra();
    this.typefileSelected = this.typefiles[Constant.ZERO_INDEX];
    this.operatingsystems = LocalStorage.getOperatingsystemExtra();
    this.operatingsystemSelected = this.operatingsystems[Constant.ZERO_INDEX];
    this.loadDefaultData();
  }

  private loadDefaultData() {
    this.loadInstallers(Page.First);
  }

  public search() {
    this.reloadInstallers();
  }

  public reloadInstallers() {
    this.loadInstallers(Page.First);
  }

  public loadInstallers(page: Page): void {
    if (this.term2Search === undefined) {
      this.term2Search = '';
    }
    switch (page) {
      case Page.First:
        this.installerUrl = Constant.ROOT_API_V1
          .concat('/signatureapptypes/')
          .concat(String(this.signatureAppTypeSelected.id))
          .concat('/typefiles/')
          .concat(String(this.typefileSelected.id))
          .concat('/operatingsystems/')
          .concat(String(this.operatingsystemSelected.id))
          .concat('/installers')
          .concat('?findby=')
          .concat(this.term2Search)
          .concat('&size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.installerUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.installerUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.installerUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.installerUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getInstallers(this.installerUrl);
  }

  private getInstallers(url: string) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.INSTALLERS');
    this.installerService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.installers = next._embedded.installers;
      } else {
        this.installers = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openAddModal() {
    this.entityName = this.translate.instant('TITLE.INSTALLERS');
    const modalRef = this.modalService.open(AddEditInstallerComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.installer = new Installer();
    modalRef.componentInstance.moreAboutInstaller = new MoreAboutInstaller();
    modalRef.componentInstance.purpose4Form = Constant.ADD;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadInstallers(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName, this.translate.instant('MESSAGE.PERMIT-ALREADY-REGISTERED'));
      }
    });
  }

  public viewDescription(installer: Installer) {
    const modalRef = this.modalService.open(ViewDescriptionComponent, {size: 'lg'});
    modalRef.componentInstance.installer = installer;
  }

  public openEditModal(installer: Installer) {
    const installer2Edit = CloneTool.do(installer);
    this.entityName = this.translate.instant('TITLE.INSTALLERS');
    const modalRef = this.modalService.open(AddEditInstallerComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.installer = installer2Edit;
    modalRef.componentInstance.moreAboutInstaller = installer._more;
    modalRef.componentInstance.purpose4Form = Constant.EDIT;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadInstallers(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openModalDelete(installer: Installer) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-INSTALLER');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-INSTALLER');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteInstaller(installer);
      }
    });
  }

  private deleteInstaller(installer: Installer) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.INSTALLERS');
    this.installerService.delete(installer).subscribe(() => {
      this.loading = false;
      this.loadInstallers(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.entityName);
    });
  }

  public getInstallerDescription(type: number): string {
    return this.signatureAppTypes.find(value => value.id === type).shortdescription;
  }

  public getTypesFileDescription(type: number): string {
    return this.typefiles.find(value => value.id === type).description;

  }

  public getTypesOperatingSystemDescription(type: number): string {
    return this.operatingsystems.find(value => value.id === type).description;

  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public download(installer: Installer) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/installers/', String(installer.hash), '/stream');
    this.installerService.getOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = installer.originalName;
      control.click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

}
